import { render, staticRenderFns } from "./ord_process.vue?vue&type=template&id=b7d3bca2&scoped=true&"
import script from "./ord_process.vue?vue&type=script&lang=js&"
export * from "./ord_process.vue?vue&type=script&lang=js&"
import style0 from "./ord_process.vue?vue&type=style&index=0&id=b7d3bca2&scoped=true&lang=less&"
import style1 from "./ord_process.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d3bca2",
  null
  
)

export default component.exports